import type { ReactNode } from "react";
import type { ModalContentProps } from "@ecco/ui/modal";
import { ModalCloseButton, ModalContent, ModalHeader } from "@ecco/ui/modal";

interface Props extends ModalContentProps {
    header?: ReactNode;
    onCloseButtonClick?: () => void;
    children?: ReactNode;
}

const Modal = ({ header, children, onCloseButtonClick, ...props }: Props) => {
    return (
        <ModalContent
            mt={0}
            mb={[0, "auto"]}
            containerProps={{
                justifyContent: ["center", "flex-end"],
                w: "inherit",
                right: 0,
                paddingRight: 0,
            }}
            {...props}
        >
            <ModalHeader display="flex">
                {header}
                <ModalCloseButton onClick={onCloseButtonClick} />
            </ModalHeader>
            {children}
        </ModalContent>
    );
};

export default Modal;
